import React from 'react';
import { designTokens, styles } from './MainPage.styles';

const faqData = [
  {
    q: "How does Book Policy Guard ensure compliance with our facility rules?",
    bullets: [
      { icon: "✅", bold: "Automatic Checks:", text: "All publications are screened against your facility’s policy database." },
      { icon: "📚", bold: "Restrictions Covered:", text: "Binding type, content, magazines/newspapers, and approved vendors." },
      { icon: "📦", bold: "Reduced Rejections:", text: "Helps ensure orders are compliant and prevents rejected packages." }
    ]
  },
  {
    q: "Are shipments traceable and fully auditable?",
    bullets: [
      { icon: "📝", bold: "Full Audit Trail:", text: "Every order is logged for accountability." },
      { icon: "📊", bold: "Real-Time Tracking:", text: "Book Policy Guard can track approvals, user submissions, and shipment details instantly." }
    ]
  },
  {
    q: "How is the safety of inmates and staff maintained?",
    bullets: [
      { icon: "⚠️", bold: "Security First:", text: "Only approved formats and content are allowed." },
      { icon: "🔒", bold: "Contraband Prevention:", text: "Items posing security risks are automatically blocked." },
      { icon: "📏", bold: "Strict Formatting:", text: "Hardcovers, spiral bindings, and prohibited content are flagged prior to shipment." }
    ]
  },
  // {
  //   q: "What experience does your company have with correctional facilities?",
  //   bullets: [
  //     { icon: "🏛️", bold: "Trusted Vendor:", text: "SureShot Books Publishing LLC has served correctional facilities nationwide for 30+ years." },
  //     { icon: "📚", bold: "Proven Expertise:", text: "Reliable delivery of books, magazines, and newspapers for the corrections community." }
  //   ]
  // },
  {
    q: "How does Book Policy Guard handle facility-specific restrictions?",
    bullets: [
      { icon: "⚙️", bold: "Automated Enforcement:", text: "Facility rules are applied automatically at checkout." },
      { icon: "🚫", bold: "Blocked Items:", text: "Any publication not allowed by your facility cannot be submitted." },
      { icon: "🛡️", bold: "Admin Oversight:", text: "Administrators can configure or review restrictions to ensure compliance." }
    ]
  },
  {
    q: "What happens if an item is rejected or non-compliant?",
    bullets: [
      { icon: "❌", bold: "Blocked at Checkout:", text: "Any non-compliant publication cannot be added to the checkout cart." },
      { icon: "💬", bold: "Notification:", text: "A message appears: “This Publication is Not accepted at this Facility.”" }
    ]
  },
  {
    q: "How often are facility rules updated in your system?",
    bullets: [
      { icon: "🔄", bold: "Continuous Updates:", text: "Policies are actively monitored and updated." },
      { icon: "📝", bold: "Facility Submissions:", text: "All Book Policy Guard Facilities can submit updates directly to keep the system current." }
    ]
  },
  // {
  //   q: "Can the platform handle high-volume orders efficiently?",
  //   bullets: [
  //     { icon: "⚡", bold: "Scalable System:", text: "Processes multiple orders simultaneously." },
  //     { icon: "✅", bold: "Compliance Checks:", text: "Each order undergoes automated checks to prevent errors." }
  //   ]
  // },
  // {
  //   q: "What accountability measures exist for staff and families using the system?",
  //   bullets: [
  //     { icon: "🏢", bold: "Facility & User Link:", text: "Every order is tied to a verified facility and user account." },
  //     { icon: "📋", bold: "Review Capabilities:", text: "Book Policy Guard allows review of submissions, approvals, and rejections at any time." }
  //   ]
  // },
  // {
  //   q: "How can we trust your service is reliable long-term?",
  //   bullets: [
  //     { icon: "🏆", bold: "Proven Track Record:", text: "Trusted vendor with 30+ years of correctional publishing experience." },
  //     { icon: "🔧", bold: "Reliable Systems:", text: "Robust processes, trained staff, and secure technology ensure consistent service." }
  //   ]
  // }
];

export default function FAQSection() {
  return (
    <section id="faq" style={{ padding: '60px 20px', backgroundColor: '#F7F7F7' }}>
      <div style={styles.sectionInner}>
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h2 style={{ fontSize: '32px', fontWeight: '800', color: '#111111' }}>Frequently Asked Questions</h2>
        </div>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {faqData.map((item, idx) => (
            <details key={idx} style={{ background: '#FFFFFF', border: '1px solid #DD1B36', borderRadius: '6px', marginBottom: '12px', padding: '16px', cursor: 'pointer' }}>
              <summary style={{ fontWeight: 'bold', fontSize: '1.05em', outline: 'none' }}>{item.q}</summary>
              <ul style={{ marginTop: '12px', listStyle: 'none', paddingLeft: '5px' }}>
                {item.bullets.map((b, i) => (
                  <li key={i} style={{ marginBottom: '8px' }}>
                    <span style={{ marginRight: '8px' }}>{b.icon}</span>
                    <strong>{b.bold}</strong> {b.text}
                  </li>
                ))}
              </ul>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}